import { createRouter, createWebHistory } from 'vue-router'
import LogIn from '../views/LogIn.vue'
import store from '../store'

const routes = [
  {
    path: '/',
    name: 'login',
    component: LogIn
  },
  {
    path: '/check',
    name: 'check',
    component: () => import('../views/Check.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // 使用 store 中的 token 而不是直接從 localStorage 讀取
  const token = store.state.token;
  console.log('Navigation guard triggered');
  console.log('Token:', token);
  console.log('Destination:', to.name);

  if (to.name === 'check' && (!token || token === 'null')) {
    console.log('Redirecting to login page');
    next({ name: 'login' });
  } else {
    console.log('Proceeding to destination');
    next();
  }
});

export default router